import { App } from 'vue';
import Keycloak, { KeycloakConfig } from 'keycloak-js';
import axios from 'axios';
import UserStore from '@apps/dashboard/src/store/usersStore';
import { UserKeyCloakResponse } from '@shared/types/user';

const userStore = UserStore();

const config: KeycloakConfig = {
	url: process.env.VUE_APP_KEYCLOAK_URL,
	clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID ?? '',
	realm: process.env.VUE_APP_KEYCLOAK_REALM ?? '',
};

// eslint-disable-next-line
// @ts-ignore
const keycloak = new Keycloak(config);

/**
 * Homepage is showing division balances
 * this times-out for some merchants
 * As a temp solution we are showing this
 * page conditionally
 */
const SHAREPEOPLE_MERCH_CODE = 'FD5CMF1wHZ1wAWSJv9ehAQXYr8majsDrKuA';
const CHEFSTABLE_MERCH_CODE = 'FD5CMGiMPvhwUqzPf2i4qqp7xY73XrVNz4g';

const hasAccessToHomepage = (userInfo: UserKeyCloakResponse): boolean => {
	return (
		userInfo.merchantCode !== SHAREPEOPLE_MERCH_CODE &&
		userInfo.merchantCode !== CHEFSTABLE_MERCH_CODE
	);
};

export default {
	install: (
		app: App,
		options: {
			authenticatedCallback: () => void;
			errorCallback: (errorInfo: string) => void;
		}
	) => {
		keycloak
			.init({
				onLoad: 'login-required',
			})
			.then((auth) => {
				// Verify authenticated
				if (auth) {
					// Fetch user info
					keycloak
						.loadUserInfo()
						.then((userInfo: UserKeyCloakResponse | Record<string, unknown>) => {
							const [verify, errorInfo] = userStore.verifyUserAttributes(
								userInfo as UserKeyCloakResponse
							);

							if (verify) {
								userStore.setUserInfo(
									userInfo as UserKeyCloakResponse,
									verify,
									hasAccessToHomepage(userInfo as UserKeyCloakResponse)
								);
								axios.defaults.headers.common = {
									'Authorization': `Bearer ${
										(userInfo as UserKeyCloakResponse).merchantToken
									}`,
									'x-user': (userInfo as UserKeyCloakResponse).email,
								};
								options.authenticatedCallback();
							} else {
								options.errorCallback(
									`Verifying user attributes failed: ${errorInfo}`
								);
							}
						});
				} else {
					options.errorCallback('Login to Keycloak failed');
				}
			});
		app.config.globalProperties.$keycloak = keycloak;
	},
};
